import { PostWhitelistDomain } from '@/Interfaces/I_WhitelistDomain';
import { customAxios } from '../index';

const getWhitelistDomainAPI = () => customAxios.get('/hktv_koc/cms/whitelist-domain');

const postWhitelistDomainAPI = (data: PostWhitelistDomain[]) =>
  customAxios.post('/hktv_koc/cms/whitelist-domain', data);

export { getWhitelistDomainAPI, postWhitelistDomainAPI };
